export const changeInvoiceStatusRfe = {
	text: "Souhaitez-vous accepter ou refuser cette facture ?",
	accept: {
		label: "Accepter"
	},
	refuse: {
		label: "Refuser"
	},
	reason: {
		label: "Motif du refus",
		placeholder: "ex : facture non conforme"
	}
}
